/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quantity_ShortInputs */

const en_quantity_short = /** @type {(inputs: Quantity_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qty`)
};

const es_quantity_short = /** @type {(inputs: Quantity_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cant.`)
};

/**
* | output |
* | --- |
* | "Qty" |
*
* @param {Quantity_ShortInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const quantity_short = /** @type {((inputs?: Quantity_ShortInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quantity_ShortInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quantity_short(inputs)
	return es_quantity_short(inputs)
});